import React from 'react';
import i18n from '../../../../../i18n';
import { formatMoney } from '../../../data/metrics';
import type { DrillPosAttribution, DrillPosAttributionArm } from '../../../types';
import { DrillTile } from './DrillTile';
import { countLabel } from './substanceFormat';

const T = 'performance:drillPos.attribution';

function Arm({
  label,
  hint,
  arm,
  unit,
}: {
  label: string;
  hint?: string;
  arm: DrillPosAttributionArm;
  unit?: string | null;
}) {
  const money = (v: number) => formatMoney(v, unit || undefined);
  return (
    <div className="dcrux-stat">
      <div className="dsub-arm-label">{label}</div>
      {hint ? <div className="dsub-n">{hint}</div> : null}
      <div className="dcrux-stat-v" style={{ marginTop: 4 }}>
        {money(arm.revenue)}
      </div>
      <div className="dsub-n">{i18n.t(`${T}.share`, { pct: arm.revenueSharePct })}</div>
      <div className="dsub-n">
        {countLabel('performance:drillPos.hours.baskets', arm.baskets)} ·{' '}
        {i18n.t(`${T}.basketShare`, { pct: arm.basketSharePct })}
      </div>
      <div className="dsub-n">
        {i18n.t(`${T}.avgBasket`, { value: money(arm.avgBasket) })}
      </div>
    </div>
  );
}

export function DrillPosAttributionSection({
  data,
  unit,
}: {
  metricKey: string;
  data: DrillPosAttribution;
  unit?: string | null;
}) {
  const linkedPct = Math.max(0, Math.min(100, data.linked.revenueSharePct));
  return (
    <DrillTile
      sectionId="pos-attribution"
      span={4}
      title={i18n.t(`${T}.title`)}
      meta={countLabel('performance:drillPos.hours.baskets', data.baskets)}
    >
      <div
        className="dsub-split-bar"
        role="img"
        aria-label={`${i18n.t(`${T}.linked`)} ${linkedPct}%`}
      >
        <span style={{ width: `${linkedPct}%` }} />
        <span style={{ width: `${100 - linkedPct}%` }} />
      </div>
      <div className="dsub-arms">
        <Arm label={i18n.t(`${T}.linked`)} arm={data.linked} unit={unit} />
        <Arm
          label={i18n.t(`${T}.unlinked`)}
          hint={i18n.t(`${T}.unlinkedHint`)}
          arm={data.unlinked}
          unit={unit}
        />
      </div>
      <p className="ddrill-tile-note">{i18n.t(`${T}.basis`)}</p>
      {data.filtersIgnored ? (
        <p className="ddrill-tile-note">
          {i18n.t('performance:drillPos.hours.filtersIgnored')}
        </p>
      ) : null}
    </DrillTile>
  );
}
